// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const administration = {
  id: "administration",
  title: "Administration",
  type: "group",
  children: [
    {
      id: "dashboard",
      title: "Dashboard",
      type: "item",
      url: "/",
    },
    {
      id: "administration",
      title: "Administration",
      type: "item",
      url: "/administration",
    },
    {
      id: "users",
      title: "Users",
      type: "item",
      url: "/users",
    },
    {
      id: "reports",
      title: "Reports",
      type: "item",
      url: "/reports",
    },
    {
      id: "activity_log",
      title: "Activity Log",
      type: "item",
      url: "/activity_log",
    },
  ],
};

export default administration;
